<template>
  <ui-container class="space-y-8 py-8">

    <!-- Header. -->
    <ui-header :title="`NCR #${item.id}`" :subtitle="item.title">
      <template #actions>
        <ui-button-new icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
        <ui-button-new icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
      </template>
    </ui-header>

    <ui-tabs active="overview" :tabs="tabs" #default="{ isActive }">
      <!-- Overview. -->
      <div v-if="isActive('overview')">
        <!-- Data. -->
        <ui-data-grid>
          <ui-data-grid-item label="Package" wide>
            <template v-if="item.package_id"><a class="text-brand" :href="item._links.frontend.package">{{ item.package_name }}</a></template>
            <template v-else>{{ item.package_name }}</template>
          </ui-data-grid-item>
          <ui-data-grid-item label="Date" :value="item.issued_date"></ui-data-grid-item>
          <ui-data-grid-item label="Contract Reference" :value="item.contract_ref"></ui-data-grid-item>
          <ui-data-grid-item label="Location Of Works" :value="item.location_of_works"></ui-data-grid-item>
          <ui-data-grid-item label="Site Address" :value="item.site_address" wide></ui-data-grid-item>
          <ui-data-grid-item label="What is the main reason or what when wrong?" wide><div class="whitespace-pre-wrap" v-html="item.reasoning"></div></ui-data-grid-item>
          <ui-data-grid-item label="Why doesn't the work meet specs?" wide><div class="whitespace-pre-wrap" v-html="item.why"></div></ui-data-grid-item>
          <ui-data-grid-item label="What can be done to prevent it from happening again?" wide><div class="whitespace-pre-wrap" v-html="item.prevention"></div></ui-data-grid-item>
          <ui-data-grid-item label="Explanatory corrective action taken." wide><div class="whitespace-pre-wrap" v-html="item.corrective"></div></ui-data-grid-item>
          <ui-data-grid-item label="Key players involved in the NCR and specs affected under the NCR." wide><div class="whitespace-pre-wrap" v-html="item.players"></div></ui-data-grid-item>
          <ui-data-grid-item v-if="item.created_by" label="Created By" :value="item.created_by.name"></ui-data-grid-item>
          <ui-data-grid-item v-if="item.last_updated_by" label="Updated By" :value="item.last_updated_by.name"></ui-data-grid-item>
          <ui-data-grid-item label="Quick action" wide>
            <div class="flex flex-col md:flex-row flex-wrap -m-2">
              <ui-button-new v-if="item.package_id" class="m-2" icon="fas fa-copy" @click="copyToDefect">Copy To Defect</ui-button-new>
            </div>
          </ui-data-grid-item>
        </ui-data-grid>
      </div>

      <!-- Files. -->
      <div v-else-if="isActive('files')">
        <filesystem
            compact="true"
            :filesystem-id="item.filesystem_id"
        ></filesystem>
      </div>

      <!-- Files. -->
      <div v-else-if="isActive('notes')">
        <notes :get-url="item._links.frontend.notes" :post-url="item._links.frontend.notes"></notes>
      </div>
    </ui-tabs>
  </ui-container>
</template>

<script>
export default {
  props: {
    item: Object,
    edit: Function,
    removeItem: Function,
  },
  data () {
    return {
      tabs: [
        { value: 'overview', label: 'Overview' },
        { value: 'files', label: 'Files' },
        { value: 'notes', label: 'Notes' },
      ],
    }
  },
  methods: {
    async copyToDefect () {
      await this.item.copyToDefect()

    },
    openDeleteModal () {
      const title = 'Are you sure you want to delete NCR #' + this.item.id + '?'
      const description = 'Deleting this NCR is irreversible. Are you sure you want to delete it?'
      eventBus.$emit('delete-modal-open', title, description, async () => {
        await this.item.delete()
        this.removeItem(this.item)

      });
    },
  },
}
</script>
